import { render, staticRenderFns } from "./SPBGReportSales.vue?vue&type=template&id=57fe4718"
import script from "./SPBGReportSales.vue?vue&type=script&lang=js"
export * from "./SPBGReportSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports